export default __webpack_public_path__ + "static/media/Tangible-Intangible.c24751f7.svg";